import {request} from '@/helpers/apiClient'
import {downloadCSVFiles, downloadCsvFromCdnUrl, getDateWithTimeString} from '@/helpers/shadcn/utils'
import {getProductCsvFile} from '@/services/ProductsService/product'
import {PRODUCTS_CONFIG} from '@/utils/constants/apiConfig/productsConfig'
import {useState} from 'react'

export const useProductButtonContainer = () => {
  const formInitialData = {
    productTemplateName: '',
    storeSelector: '',
    actions: '',
    numberOfDays: '',
    numberOfPoints: '',
    schedule: '',
    startDate: '',
    endDate: '',
    mediaFile: [],
  }
  const [btnDisabled, setBtnDisabled] = useState(false)

  const onDownloadTemplateBtnClick = async selectedIds => {
    setBtnDisabled(true)
    if (btnDisabled) {
      return
    }
    const data = await getProductCsvFile({}, `sortBy=productId&order=DESC`)
    const fileName = `Product_${getDateWithTimeString()}`
    downloadCSVFiles(data, fileName)
    setBtnDisabled(false)
  }

  const onDownloadProductEnrichmentTemplate = async () => {
    try {
      const data = await request(PRODUCTS_CONFIG.PRODUCT_ENRICHMENT_TEMPLATE_DOWNLOAD('includeData=true'))
      const fileName = `Product_Enrichment_Template_${getDateWithTimeString()}`
      downloadCsvFromCdnUrl(data.cdnUrl, fileName)
    } catch (error) {
      console.error('Error downloading enrichment template:', error)
    }
  }

  const [isProductListUploadModal, toggleProductListUploadModal] = useState(false)
  const [isMultipleImagesModal, toggleMultipleImagesModal] = useState(false)
  const [formData, setFormData] = useState({...formInitialData})

  return {
    isProductListUploadModal,
    toggleProductListUploadModal,
    isMultipleImagesModal,
    toggleMultipleImagesModal,
    setFormData,
    formData,
    onDownloadTemplateBtnClick,
    onDownloadProductEnrichmentTemplate,
  }
}
